module.exports = __webpack_public_path__ + "020ace32cfb3749f3ab0e7c8484438f7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-14.png
// module id = 3121
// module chunks = 0